import { Pet } from "../../core/pet";
import { Resistance, type AbnormalResistance } from "../../core/pet";
import { AbilityValue } from "../../core/abval";
import * as type from "../../core/type";
import * as skill from "../skill/盖亚";
import { Soulmark } from "../../core/soulmark";
import { Skin } from "../../core/skin";

export class 盖亚 extends Pet {
    /**
     *
     * @param ablis 能力值
     * @param resis 伤害抗性
     * @param abnormalResistance 异常抗性，默认无
     */
    constructor(ablis: AbilityValue, resis: Resistance, abnormalResistance: ReadonlyArray<Readonly<AbnormalResistance>> = []) {
        super(261, "盖亚", type.战斗, ablis);
        this.抗性 = resis;
        this.异常抗性 = abnormalResistance;
        this.魂印 = new Soulmark([
            "登场时自身开启武道。初始为血之道。武道会以血之道、邪之道、天之道、血之道的轨迹进行衍化。每完成一次完成轨迹的衍化，自身恢复全部PP值。",
            "战斗阶段结束时自身恢复最大体力的1/6，自身处于血之道时效果翻倍；自身使用技能时附加对手最大体力1/6的百分比伤害，自身处于邪之道时效果翻倍；自身造成的攻击伤害提升50%，自身处于天之道时效果翻倍",
            "血之道：自身抵挡本场战斗自身在场的前10回合受到的攻击，触发后衍化。",
            "邪之道：自身抵挡本次在场超过2回合的精灵的攻击，触发后衍化。",
            "天之道：自身抵挡非致命一击，触发后衍化。",
        ]);
        this.技能组 = [
            skill.战·破元归衍,
            skill.战·神罡不灭,
            skill.战·归真复元,
            skill.战·日月逆行,
            skill.战神·破天闪,
        ];
        this.皮肤组.push(new Skin(1400727, "灭战神决·盖亚"));
    }
}
